export const environment = {
  production: true,
  apiUrl: 'https://api.hub.iasis.app',
  idProfissional: 'REPLACETHISID',
  idParceiro: '621d0b81c083436f62e2e64b'
};
